import styles from './settings.module.css';

export function KeyValue({ k, v }: { k: string; v: string }) {
  return (
    <div className={styles.kv}>
      <dt className={styles.kvKey}>{k}</dt>
      <dd className={styles.kvValue}>{v}</dd>
    </div>
  );
}
